var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4.16667H8.33333V12.5H6.66667V4.16667ZM10 7.5H11.6667V12.5H10V7.5ZM3.33333 9.16667H5V12.5H3.33333V9.16667ZM10 1.66667H1.66667V15H13.3333V5H10V1.66667ZM0 0.8265C0 0.370042 0.372908 0 0.832083 0H10.8333L14.9998 4.16667L15 15.8271C15 16.2908 14.6292 16.6667 14.1722 16.6667H0.827833C0.370633 16.6667 0 16.2872 0 15.8402V0.8265Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.d5624d8f29ded2390c5dff72df619181.svg";
export { ForwardRef as ReactComponent };